<template>
  <div>
    <div class="top_div">
      <img class="home_banner" src="../../static/img/品牌页-海报-标注11.jpg" />
      <div class="div_top_title">
        <p>即将为您展现集壹产品，请选择</p>
        <div class="flex_container">
          <div class="left" @click="openLink(List[1].url)">
            <img :src="List[1].img" />
            <p class="p_title_sub">{{ List[1].title }}</p>
          </div>
          <div class="right" @click="openLink(List[0].url)">
            <img :src="List[0].img" />
            <p class="p_title_sub">{{ List[0].title }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      List: [
        {
          img: "",
          title: "",
          url: "",
        },
      ],
    };
  },
  components: {},
  mounted() {
    this.Init();
  },
  methods: {
    Init() {
      this.getSimple();
    },
    openLink(link) {
      window.open(link, "_blank");
    },
    getSimple() {
      let that = this;
      this.$axios
        .get("app/jumppager/list")
        .then(function (response) {
          console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.List = response.data.page.list;
            console.log(that.List);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.top_div {
  height: 100%;
  position: relative;
}

.home_banner {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: #ec8938;

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.div_top_title {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: -20%;
  color: #f2f2f2;
  font-size: 2.2rem;
  font-family: light;
  text-shadow: 3px 3px 3px rgba(0, 73, 133, 0.6);

  .p_title_sub {
    margin-top: 1rem;
    font-family: thin;
    font-size: 1.6rem;
  }

  .litter_line_top {
    margin: 1rem auto 3rem;
    background-color: var(--textWhiteColor40);
    box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.4);
    height: 1px;
    width: 6%;
  }
}

.flex_container {
  width: 50%;
  margin: 5rem auto 0;
  display: flex;
  align-items: baseline;
  align-content: center;
  position: relative;

  img {
    max-height: 15rem;
  }

  .left {
    transition: all 0.4s;
    position: absolute;
    left: 0;
  }

  .right {
    transition: all 0.4s;
    position: absolute;
    right: 0;
  }

  .left:hover {
    transform :translateY(-1rem);
    transition: all 0.4s;
  }

  .right:hover {
    transform :translateY(-1rem);
    transition: all 0.4s;
  }

}

@media screen and (max-width: 1200px) {
  .top_div {
    height: 100vh;
  }

  .home_banner {
    height: 100%;
    object-fit: cover;
  }

  .flex_container {
    width: 80%;

    img{
      height:10rem;
    }
  }
}
</style>
